import { TopicId } from '~/dashboard/utils/learningPath.utils'
import { TheoryType } from '~/types/theory'

export interface Context {
  results: Result[]
  customizedResults: Result[]
  onHistoryClick?: (query: string) => void
  prSearch?: string[]
  setPrSearch?: (queries: string[]) => void
  open: boolean
  onNavigate: () => void
}

export interface Result {
  type: Type & TheoryType
  header: string
  url: string
  path: string
  breadcrumbs: string
  topic: string
  description: string | null
}

export enum Type {
  ALL = 'all',
  BOOTCAMP = 'bootcamp',
  ENCYCLOPEDIA = 'encyclopedia',
  DRILL = 'drill',
  SOFTWARE = 'software',
}
export interface SearchResult {
  query: string
  customizedResult: Result[]
  result: Result[]
}

export interface SearchData {
  query: string
  result: Result[]
  customizedResult: Result[]
}

export interface TopicSearch {
  bootcamp: string
  mathPreview: string
  mathTopic: TopicId
  taskId: string
  subject?: string
  subjectOrder?: number
  onlyEn?: boolean
  path?: string
}

export interface SearchResultsAlt {
  bootcamp_title: string
  index: string
  is_title: number
  math_preview: string
  rank: number
  task_id: string
  topic: string
  type: string
  is_language: number
  path: string
}
